import React from 'react';
import { connect } from 'react-redux';
import * as StyledLocationFilter from './priceFilter.styles';
import FilterMenu from '../filterMenu';
import { setPriceFilters } from '../../../actions/filtersActions';

const PriceFilter = ({
	filtersReducer,
	dispatch
}) => {
	const { prices, selectedPrices } = filtersReducer;

	const onSaveClick = (values) => {
		// TODO: Set values to hash
		dispatch(setPriceFilters(values));
	};

	return (
		<StyledLocationFilter.Wrapper>
			<FilterMenu
				values={prices}
				selectedValues={selectedPrices}
				onSave={onSaveClick} />
		</StyledLocationFilter.Wrapper>
	);
};

const mapStateToProps = ({ filtersReducer }) => ({
	filtersReducer
});

export default connect(mapStateToProps)(PriceFilter);
